import { render, staticRenderFns } from "./SaleReportsSG.vue?vue&type=template&id=dff2650a"
import script from "./SaleReportsSG.vue?vue&type=script&lang=js"
export * from "./SaleReportsSG.vue?vue&type=script&lang=js"
import style0 from "./SaleReportsSG.vue?vue&type=style&index=0&id=dff2650a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports